import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { MainApiService } from '_services';
import { processResponse, processError } from '_helpers/api';

export const getProducts = createAsyncThunk(
  'products/getProducts',
  async function (_, { rejectWithValue }) {
    try {
      const response = await MainApiService.getProducts();
      return processResponse(response);
    } catch (e) {
      return rejectWithValue(processError(e));
    }
  }
);

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    data: [],
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default productsSlice.reducer;
